import { Refinement } from '@rbi-ctg/frontend';
import { IPickerAspectUiPattern } from '@rbi-ctg/menu';
import { MenuObjectTypes } from 'enums/menu';
import {
  IGetComboPlusQuery,
  IGetItemPlusQuery,
  IGetPickerPlusQuery,
} from 'generated/sanity-graphql';
import { IUsePricingFunctionHookReturnType } from 'types/menu-pricing';
import { CartEntryType } from 'utils/cart/types';

import { IMainMenuContext } from './main-menu/types';
import { IMenuOptionsContext } from './menu-options/types';

export type IMenuContext = IMainMenuContext &
  IMenuOptionsContext & {
    showBurgersForBreakfast: boolean;
  } & IUsePricingFunctionHookReturnType;

export type IMenuCombo = NonNullable<IGetComboPlusQuery['Combo']> & {
  _type: MenuObjectTypes.COMBO;
};
export type IMenuItem = NonNullable<IGetItemPlusQuery['Item']> & {
  _type: MenuObjectTypes.ITEM;
};
export type IMenuPicker = NonNullable<IGetPickerPlusQuery['Picker']> & {
  _type: MenuObjectTypes.PICKER;
};
export type IMenuObject = IMenuCombo | IMenuItem | IMenuPicker;

export type IsCartEntryType<MenuType extends { type: CartEntryType }> = Refinement<
  object,
  MenuType
>;

export enum PickerAspectUiPattern {
  SELECTOR = 'selector',
  RADIO = 'radio',
}

export const isUiPatternRadio = (p: IPickerAspectUiPattern): boolean =>
  p.uiPattern === PickerAspectUiPattern.RADIO;

export enum SectionUiPattern {
  STANDARD = 'standard',
  STACKED = 'stacked',
  INLINE_TILE = 'inlineTile',
}
